export interface ICloseRA {
  id: number;
  code: string;
  description: string | null;
  member_name: string;
  location_name: string;
  billing_tin: string;
  provider_name: string;
  treated_provider_id: number | null;
  treated_provider_name: string | null;
  somos_provider_id: number;
  somos_member_id: number;
  hcc_category: string;
  hcc_description: string;
  app: boolean;
  present: boolean;
  inactive: boolean;
}

export class CloseRA implements ICloseRA {
  id: number;
  code: string;
  description: string | null;
  member_name: string;
  location_name: string;
  billing_tin: string;
  provider_name: string;
  treated_provider_id: number | null;
  treated_provider_name: string | null;
  somos_provider_id: number;
  somos_member_id: number;
  hcc_category: string;
  hcc_description: string;
  app: boolean;
  present: boolean;
  inactive: boolean;

  constructor(data: ICloseRA) {
    Object.assign(this, data);
  }

  static fromObject(data: ICloseRA): CloseRA {
    return new CloseRA(data);
  }

  static fromObjectArray(data: ICloseRA[]): CloseRA[] {
    return data.map(CloseRA.fromObject);
  }
}

export interface IResultClosedRa {
  count: number;
  next: string | null;
  previous: string | null;
  results: ICloseRA[];
}

export class ResultClosedRa implements IResultClosedRa {
  count: number = 0;
  next: string | null = null;
  previous: string | null = null;
  results: CloseRA[] = [];

  constructor(data?: IResultClosedRa) {
    if (data) {
      this.count = data.count;
      this.next = data.next;
      this.previous = data.previous;
      this.results = CloseRA.fromObjectArray(data.results);
    }
  }

  static fromObject(data: IResultClosedRa): ResultClosedRa {
    return new ResultClosedRa(data);
  }
}
